export default __webpack_public_path__ + "/dist/images/graph1.png";